import { Spin } from 'antd';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import ReadOnly, { ReadView } from '../../../../common/ReadOnly';
import { dealTypes } from '../../../../login/utils/Status';
import { commaSeperator } from '../../../../utils/validation';
//import { getInterestRateInvestment } from '../../utils';

const width = 'w-1/2 lg:w-1/5 xl:w-1/6';

const InvestmentDetailCard: React.FC = () => {
    const investmentDetails = useSelector((state: RootState) => state.investments.investmentDetails);
    const loading = useSelector((state: RootState) => state.investments.detailLoading);

    const dealType = useMemo(() => {
        const type = investmentDetails?.deal?.info.summary?.dealType;
        const bookingUUID = investmentDetails?.bookingUUID;
        if (type) {
            return type;
        }
        if (bookingUUID) {
            return dealTypes.debt;
        }
        return undefined;
    }, [investmentDetails]);

    const readOnlyData: ReadView[] = [
        {
            data: [
                {
                    key: 'Deal',
                    value: investmentDetails?.deal?.info?.summary?.title,
                    width: width,
                    notShow: dealType === dealTypes.fund,
                },
                {
                    key: 'Subscription Date',
                    value: investmentDetails?.fundInvestmentInfo?.subscriptionDate?.date
                        ? moment(investmentDetails?.fundInvestmentInfo?.subscriptionDate?.date).format('DD/MM/YYYY')
                        : '-',
                    width: width,
                    notShow: dealType === dealTypes.debt || dealType === dealTypes.equity,
                },
                {
                    key: 'Investment Amount',
                    value: investmentDetails?.amount?.amountUpto2dp
                        ? `${investmentDetails.amount.currency} ${commaSeperator(
                              parseFloat(String(investmentDetails.amount.amountUpto2dp || 0)).toFixed(2),
                          )}`
                        : '-',
                    width: width,
                },
                {
                    key: 'Redeemed Amount',
                    value: investmentDetails?.fundInvestmentInfo?.redeemedAmount?.amountUpto2dp
                        ? `${investmentDetails?.fundInvestmentInfo?.redeemedAmount?.currency} ${commaSeperator(
                              parseFloat(
                                  String(investmentDetails?.fundInvestmentInfo?.redeemedAmount?.amountUpto2dp),
                              ).toFixed(2),
                          )}`
                        : '-',
                    width: width,
                    notShow: dealType === dealTypes.debt || dealType === dealTypes.equity,
                },
                {
                    key: 'Balance Amount',
                    value: investmentDetails?.fundInvestmentInfo?.balanceAmount?.amountUpto2dp
                        ? `${investmentDetails?.fundInvestmentInfo?.balanceAmount?.currency} ${commaSeperator(
                              parseFloat(
                                  String(investmentDetails?.fundInvestmentInfo?.balanceAmount.amountUpto2dp),
                              ).toFixed(2),
                          )}`
                        : investmentDetails?.amount?.amountUpto2dp
                        ? `${investmentDetails.amount.currency} ${commaSeperator(
                              parseFloat(String(investmentDetails.amount.amountUpto2dp || 0)).toFixed(2),
                          )}`
                        : '-',
                    width: width,
                    notShow: dealType === dealTypes.debt || dealType === dealTypes.equity,
                },
                {
                    key: 'Status',
                    value: investmentDetails?.derived?.status,
                    width: width,
                    notShow: dealType === dealTypes.debt || dealType === dealTypes.equity,
                },
                {
                    key: dealType === dealTypes.fund ? 'Mandate' : 'Instrument Type',
                    value: investmentDetails?.deal?.info?.summary?.instrumentType,
                    width: width,
                },
                {
                    key: 'Domicile',
                    value: investmentDetails?.deal?.fundDetails?.info?.domicile,
                    width: width,
                    notShow: dealType === dealTypes.debt || dealType === dealTypes.equity,
                },
                {
                    key: 'Distribution Frequency',
                    value: investmentDetails?.deal?.info.summary?.terms?.distribution,
                    width: width,
                    notShow: dealType === dealTypes.debt || dealType === dealTypes.equity,
                },
                {
                    key: 'Lock-in Period',
                    value: investmentDetails?.deal?.fundDetails?.info?.lockInPeriodInMonths,
                    width: width,
                    notShow: dealType === dealTypes.debt || dealType === dealTypes.equity,
                },
                {
                    key: 'Investment Date',
                    value: investmentDetails?.investmentDate?.date?.date
                        ? moment(investmentDetails?.investmentDate?.date?.date).format('DD-MMM-YY')
                        : 'NA',
                    width: width,
                    notShow: dealType === dealTypes.fund,
                },
                {
                    key: 'Maturity Date',
                    value: investmentDetails?.booking?.generalTerms?.maturityDate?.date
                        ? moment(investmentDetails.booking.generalTerms.maturityDate.date).format('DD-MMM-YY')
                        : 'NA',
                    width: width,
                    notShow: dealType === dealTypes.fund || dealType === dealTypes.equity,
                },
                {
                    key: 'Interest Rate (p.a.)',
                    // value: investmentDetails?.deal?.info.summary?.terms?.interestRates
                    //     ? getInterestRateInvestment(investmentDetails?.deal?.info.summary?.terms?.interestRates)
                    //     : '-',
                    value: investmentDetails?.derived?.interestRate
                        ? `${investmentDetails?.derived?.interestRate}`
                        : 'NA',
                    width: width,
                    notShow: dealType === dealTypes.fund || dealType === dealTypes.equity,
                },
                {
                    key: 'Country',
                    value: investmentDetails?.issuer?.country,
                    width: width,
                    notShow: dealType === dealTypes.fund,
                },
                {
                    key: 'Tenor (Months)',
                    value: investmentDetails?.deal?.info.summary?.terms?.tenorInMonths,
                    width: width,
                    notShow: dealType === dealTypes.fund || dealType === dealTypes.equity,
                },
                // {
                //     key: 'Repayment Status',
                //     value: investmentDetails?.status,
                //     width: width,
                //     notShow:
                //         dealType === dealTypes.fund ||
                //         dealType === dealTypes.equity,
                // },
            ],
        },
    ];

    return (
        <div className=" bg-white py-6 px-4 mt-6 md:mt-10">
            {!loading && (
                <>
                    <p className="font-semibold WorkSans-Semibold text-lg text-[#20222B] uppercase">
                        {investmentDetails?.issuer?.name}
                    </p>
                    <div className="pt-3">
                        <ReadOnly list={readOnlyData} />
                    </div>
                </>
            )}
            {loading && (
                <div className="flex justify-center items-center">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default InvestmentDetailCard;
